import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataMainOccupationSchema = validator.object().shape({
  mainOccupation: validator.string().emptyToNull().label("職種").required(),
  fmMainOccupationRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("期間更新CSVのコード（列FM）")
    .required(),
});
